import styled from "styled-components";

export const ArrowIconStyled = styled.div`
  margin-right: 10px;
  margin-top: 15px;
  height: 35px;
  width: 38px;
`;
